import { classNames, createRef } from 'libs/react';
import { useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from 'components/Button';
import { Form } from 'components/form/Form';
import { FormField } from 'components/form/FormField';
import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { Image } from 'components/Image';
import { Text } from 'components/Text';
import { Case } from 'components/util/Case';
import { Else } from 'components/util/Else';
import { When } from 'components/util/When';
import { Waiter } from 'components/Waiter';
import { React } from 'libs/react';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { SaleItemGroupsQuery } from 'graphql/SaleItemGroup/queries/SaleItemGroupsQuery';
import { Closeable } from 'components/util/Closeable';
import { Spinner } from 'components/Spinner';
import { SaleItemSearchListQuery } from 'graphql/SaleItem/queries/SaleItemSearchListQuery';
import './DealConfiguratorSearch.scss';
/**
 * @component DealConfiguratorSearch
 * @since 1.0.0
 */
export function DealConfiguratorSearch(props) {
    var _a;
    const { style, isMenu } = Object.assign({ style: 'normal' }, props);
    const [search, setSearch] = useState('');
    // TODO : change this to global account settings
    const [filter, setFilter] = useState('');
    const [open, setOpen] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const inputRef = createRef();
    const { configureItem, browsePicker } = useDealConfiguratorContext();
    const [data] = useQuery(SaleItemGroupsQuery);
    /**
     * @function onSearch
     * @since 1.0.0
     * @hidden
     */
    const onSearch = (value) => {
        if (value) {
            setOpen(true);
        }
        setSearch(value);
    };
    /**
     * @function onFilter
     * @since 1.0.0
     * @hidden
     */
    const onFilter = (value) => {
        setFilter(value);
        setOpenFilter(false);
    };
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    const onBlur = () => {
        setSearch('');
    };
    /**
     * @function handleCloseOverlay
     * @since 1.0.0
     * @hidden
     */
    const handleCloseOverlay = () => {
        onBlur();
        setOpen(false);
        setOpenFilter(false);
    };
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    const onClick = () => {
        setSearch('');
        setOpenFilter(!openFilter);
    };
    const className = classNames('deal-configurator-search', 'deal-configurator-search--' + style, props.className);
    const options = [
        {
            label: t('All'),
            value: ''
        },
        ...((data === null || data === void 0 ? void 0 : data.saleItemGroups)
            ? data.saleItemGroups
                .filter((group) => group.useInQueryBuilder)
                .map((group) => ({
                label: group.title,
                value: group.id
            }))
            : [])
    ];
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-configurator-search-main" },
            !isMenu && (React.createElement("div", { className: "deal-configurator-search-head" },
                React.createElement("div", { className: "deal-configurator-search-tool-bar" },
                    React.createElement("div", { className: "deal-configurator-search-tool-bar-title" }, t('Add Product')),
                    React.createElement("div", { className: "deal-configurator-search-tool-bar-item" },
                        React.createElement(Button, { style: "primary", label: t('Help me choose'), onPress: () => browsePicker(true) }))))),
            open && (React.createElement("div", { id: "multi-select-backdrop-overlay", onClick: handleCloseOverlay })),
            React.createElement(Closeable, { onClose: () => setOpenFilter(false) },
                React.createElement("div", { className: "deal-configurator-search-body" },
                    React.createElement(Form, null,
                        React.createElement(FormGroup, null,
                            React.createElement(Button, { label: (_a = options.find((o) => o.value === filter)) === null || _a === void 0 ? void 0 : _a.label, badge: openFilter ? 'chevron-up' : 'chevron-down', onPress: onClick, className: "deal-configurator-filter-button" }),
                            React.createElement(FormField, null,
                                React.createElement(FormInput, { name: "search", picto: "magnifying-class", placeholder: t('Search Product'), value: search, onChange: onSearch, ref: inputRef, onFocus: () => !search && setOpenFilter(false) })))),
                    (openFilter || open) && (React.createElement(DealConfiguratorSearchResult, { search: search, filter: filter, onConfigure: configureItem, filterOptions: options, openFilter: openFilter, onFilter: onFilter })))))));
}
/**
 * @component DealConfiguratorSearchResult
 * @since 1.0.0
 * @hidden
 */
function DealConfiguratorSearchResult(props) {
    var _a;
    let { search, filter, filterOptions, openFilter, onFilter } = props;
    search = search === null || search === void 0 ? void 0 : search.trim();
    const { deal } = useDealConfiguratorContext();
    // TODO : change this to global account settings or better way to do this
    let configuration;
    if (filter == 'CONFIGURABLE' || filter == 'SIMPLE' || filter == 'FINISHED') {
        configuration = filter;
    }
    const [data, ready] = useQuery(SaleItemSearchListQuery, {
        variables: {
            input: {
                search,
                configuration,
                groupId: filter &&
                    filter != 'CONFIGURABLE' &&
                    filter != 'SIMPLE' &&
                    filter != 'FINISHED'
                    ? filter
                    : undefined,
                optionConfiguration: ['ITEM_ONLY'],
                active: true,
                fromInternal: true,
                partnerId: (_a = deal === null || deal === void 0 ? void 0 : deal.partner) === null || _a === void 0 ? void 0 : _a.id,
                limit: 20
            }
        },
        skip: search == ''
    });
    const activeVariants = data === null || data === void 0 ? void 0 : data.saleItems.items.map((saleItem) => (Object.assign(Object.assign({}, saleItem), { variants: saleItem.variants.filter((variant) => variant.active) })));
    return (React.createElement("div", { className: `deal-configurator-search-result ${openFilter && 'open-filter-active'}` },
        search && !ready && React.createElement(Spinner, null),
        search && ready && (React.createElement(Waiter, { until: ready },
            React.createElement(When, null,
                React.createElement(Case, { is: activeVariants === null || activeVariants === void 0 ? void 0 : activeVariants.length }, activeVariants === null || activeVariants === void 0 ? void 0 : activeVariants.map((item) => {
                    var _a;
                    return (React.createElement("div", { key: item.id, className: "deal-configurator-search-result-item" },
                        React.createElement("div", { className: "deal-configurator-search-result-item-container" },
                            React.createElement(Image, { className: "deal-configurator-search-result-item-image", source: (_a = item.image) === null || _a === void 0 ? void 0 : _a.image.url }),
                            React.createElement(Text, { className: "deal-configurator-search-result-item-title", value: item.title })),
                        React.createElement("div", { className: "deal-configurator-search-result-item-foot" },
                            React.createElement(When, null,
                                React.createElement(Case, { is: item.configuration == 'SIMPLE' },
                                    React.createElement(Button, { style: "circle", picto: "plus", onPress: () => { var _a; return (_a = props.onConfigure) === null || _a === void 0 ? void 0 : _a.call(props, item); } })),
                                React.createElement(Else, null,
                                    React.createElement(Button, { style: "circle", picto: "gear", onPress: () => { var _a; return (_a = props.onConfigure) === null || _a === void 0 ? void 0 : _a.call(props, item); } }))))));
                })),
                React.createElement(Else, null,
                    React.createElement("div", { className: "deal-configurator-search-empty" }, t('No products matched your search.')))))),
        openFilter && (React.createElement("div", { className: "deal-configurator-filter-result" }, filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.map((option, index) => (React.createElement("div", { onClick: () => onFilter && onFilter(option.value), key: index }, option.label)))))));
}
